<template>
  <div class="compound public-content" ref="publicContent">
    <div class="breadcrumb">版式</div>
    <div class="add-category">
      <el-form inline ref="form" :model="searchLayoutVo" label-width="100px">
        <el-form-item label="页面类型：">
          <el-select v-model="searchLayoutVo.pageTypeCode" clearable placeholder="请选择">
            <el-option label="" value="">全部</el-option>
            <el-option v-for="item in $store.state.pms.pageTypeList" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宽高：">
          <el-input v-model="searchLayoutVo.templateSize" placeholder="请输入宽高" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板性质：">
          <el-select clearable v-model="searchLayoutVo.propertyId" placeholder="请选择">
            <el-option label="" value="">全部</el-option>
            <el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期：">
          <el-date-picker v-model="value2" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期"
            end-placeholder="请选择结束日期" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="照片数量：">
          <el-input v-model="searchLayoutVo.imageCount" clearable placeholder="请输入图片数量"></el-input>
        </el-form-item>
        <div class="asdasd">
          <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
          <el-button type="primary" v-permission="'pts:admin:layout:setShow'" round @click="hideAll">批量隐藏</el-button>
        </div>
      </el-form>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" ref="multipleTable" @selection-change="handleSelectionChange" border>
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="编号" prop="id"></el-table-column>
          <el-table-column label="版式缩略图">
            <template slot-scope="scope">
              <el-image :src="scope.row.layoutThumbnail" :preview-src-list="[scope.row.layoutThumbnail]" fit="cover">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="页面类型" prop="typeName"></el-table-column>
          <el-table-column label="模板性质" prop="propertyName"></el-table-column>
          <el-table-column label="照片张数" prop="imageCount"></el-table-column>
          <el-table-column label="宽高" prop="templateSize"></el-table-column>
          <el-table-column label="创建日期" prop="createdTime"></el-table-column>
          <el-table-column label="前端是否显示" prop="isShow" v-permission="'pts:admin:layout:setShow'">
            <template slot-scope="scope">
              <el-switch @change="changShow(scope.row)" v-model="scope.row.isShow" :active-value="1" :inactive-value="0" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" v-permission="'pts:admin:layout:detail'" @click="check(scope.row)">查看</span><br>
              <span class="color-blue" v-permission="'pts:admin:layout:batchRemove'" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该版式？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteFormat(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VPagination from '@/components/Pagination/index'
import { layoutGetLayoutList, propertyGetPropertyList, layoutBatchRemove, ayoutSetShow, pageTypeList } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      pageTypeList: [],
      value2: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      compoundType: [],
      tableData: [],
      searchLayoutVo: {
        createTimeBegin: '',
        createTimeEnd: '',
        id: '',
        imageCount: '',
        page: 1,
        pageTypeCode: '',
        propertyId: '',
        templateSize: ''
      },
      propertyList: [],
      multipleSelection: [],
      rememberScroll: null
    }
  },
  mounted () {
    console.log('mounted')
  },
  async created () {
    console.log('created')
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.searchLayoutVo = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.value2 = [this.searchLayoutVo.createTimeBegin, this.searchLayoutVo.createTimeEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('offsetY')
    }
    await this.onSubmit()
    // this.getPageTypeList()
    await this.getPropertyName()
    this.$store.dispatch('pms/getPageTypeList')
    this.$nextTick(() => {
      let that = this
      that.$refs.publicContent.addEventListener('scroll', that.handleScroll)
      // 根据本地缓存取出初始值并渲染页面
      that.rememberScroll = Number(sessionStorage.getItem('offsetY'))
      that.$refs.publicContent.scrollTo(0, that.rememberScroll)
    })
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
    if (this.rememberScroll) {
      sessionStorage.setItem('offsetY', this.rememberScroll)
      // console.log('rememberScroll=', this.rememberScroll)
    } else {
      sessionStorage.setItem('offsetY', 0)
    }
  },
  watch: {
    value2 (val) {
      this.searchLayoutVo.createTimeBegin = val === null ? '' : val[0]
      this.searchLayoutVo.createTimeEnd = val === null ? '' : val[1]
    }
  },
  methods: {
    handleScroll (e) { // vue 方法中可直接加e获取event，当@click方法不加括号默认传event参数。      
      const target = e.target // 获取元素目标
      if (target) {
        this.rememberScroll = target.scrollTop// 获取离页面上方高度
        // console.log(this.rememberScroll, 'handleScroll')
      } else {
        this.rememberScroll = 0
      }
    },
    check (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchLayoutVo))
      this.$router.push({ path: '/checkformat', query: { id: row.id } })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    hideAll () {
      let idList = this.multipleSelection.map(item => {
        return item.id
      })

      ayoutSetShow({ idList, isShow: 0 }).then(res => {
        if (res.data.success) {
          this.onSubmit()
        }
      })
    },
    // 获取模板性质管理
    async getPropertyName () {
      await propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyList = res.data.data
        }
      })
    },
    // 删除
    deleteFormat (id) {
      layoutBatchRemove([id]).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    // 设置前端显示
    changShow (row) {
      ayoutSetShow({ idList: [row.id], isShow: row.isShow }).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
        }
      })
    },
    // 获取页面类型
    // getPageTypeList () {
    //   pageTypeList().then(res => {
    //
    //     if (res.data.success) {
    //       this.pageTypeList = res.data.data
    //     }
    //   })
    // },
    // 获取版式列表
    async onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.searchLayoutVo))
      }
      await layoutGetLayoutList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchLayoutVo: this.searchLayoutVo }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>

<style scoped lang="less">
.compound {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  // overflow: auto;
  -webkit-overflow-scrolling: touch;

  // &::-webkit-scrollbar {
  //   display: none;
  // }
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}

.asdasd {
  float: right;
  margin-right: 20px;
}
</style>
